// Force English locale for all date inputs
export const setupDateInputLocale = () => {
  if (typeof window !== 'undefined') {
    // Set the default locale for date inputs
    const style = document.createElement('style');
    style.textContent = `
      input[type="date"]::-webkit-datetime-edit {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
      }
      input[type="date"]::-webkit-datetime-edit-fields-wrapper {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
      }
      input[type="date"]::-webkit-datetime-edit-text {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
      }
      input[type="date"]::-webkit-datetime-edit-month-field {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
      }
      input[type="date"]::-webkit-datetime-edit-day-field {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
      }
      input[type="date"]::-webkit-datetime-edit-year-field {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
      }
    `;
    document.head.appendChild(style);

    // Set lang attribute on all date inputs
    const observer = new MutationObserver(() => {
      const dateInputs = document.querySelectorAll('input[type="date"]');
      dateInputs.forEach((input) => {
        const htmlInput = input as HTMLInputElement;
        htmlInput.setAttribute('lang', 'en-US');
        htmlInput.style.fontFamily = "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial setup
    const dateInputs = document.querySelectorAll('input[type="date"]');
    dateInputs.forEach((input) => {
      const htmlInput = input as HTMLInputElement;
      htmlInput.setAttribute('lang', 'en-US');
      htmlInput.style.fontFamily = "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";
    });
  }
};
